module.exports = __webpack_public_path__ + "img/folder-icon.98f90e92.svg";